module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('SmartHrLocalList', {
    attrs: {
      "module-type": "GROWTH",
      "title": "新人成长",
      "group-name": "员工关系"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70ab800b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/smartHr/SmartHrGrowth.vue
// module id = 1879
// module chunks = 8